export default {
  methods: {
    async getExcel (urlExcel, filename) {
      try {
        const { headers, data } = await this.$http.excel.get(urlExcel)
        const type = headers['content-type']
        const url = window.URL.createObjectURL(new Blob([data], { type }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${filename}.csv`)
        document.body.appendChild(link)
        link.click()
      } catch (error) {
        window.alert('😓 Ha ocurrido un error al descargar el archivo')
      }
    }
  }
}
